// components/Activity.js
import "./Activity.css";
import React, { useState } from "react";
import useApiService from "../hooks/useApiService.js";
import FollowersDashboard from "../components/dashboard/FollowersDashboard.js";
import ViewsDashboard from "../components/dashboard/ViewsDashboard.js";
import LikesDashboard from "../components/dashboard/LikesDashboard.js";
import ActivityDashboard from "../components/dashboard/ActivityDashboard.js";
import TopCitiesDashboard from "../components/dashboard/TopCitiesDashboard.js";
import AgeDashboard from "../components/dashboard/AgeDashboard.js";

function Activity() {
  const [followersDashboardText, setFollowersDashboardText] = useState("Month");
  const [viewsDashboardText, setViewsDashboardText] = useState("Month");
  const [likesDashboardText, setLikesDashboardText] = useState("Month");
  const [activityDashboardText, setActivityDashboardText] = useState("Hour");
  const [selectedGenre, setSelectedGenre] = useState("INSIGHT");

  const { data: followersList, loading: loadingFollowers } = useApiService(
    "api/influencer_platform/metrics/follow_by_date",
    "GET"
  );

  const { data: viewsList, loading: loadingViews } = useApiService(
    "api/influencer_platform/metrics/views_by_date",
    "GET"
  );

  const { data: likesList, loading: loadingLikes } = useApiService(
    "api/influencer_platform/metrics/like_by_date",
    "GET"
  );

  const { data: activityList, loading: loadingActivity } = useApiService(
    "api/influencer_platform/metrics/activity_follower_by_date",
    "GET"
  );

  const { data: topCitiesList, loading: loadingTopCities } = useApiService(
    "api/influencer_platform/metrics/follow_by_city",
    "GET"
  );

  const { data: ageList, loading: loadingAge } = useApiService(
    "api/influencer_platform/metrics/follow_by_age_range",
    "GET"
  );

  const handleGenreClick = (text) => {
    setSelectedGenre(text);
  };

  const handleDashboardClick = (index, type) => {
    if (index === "0") {
      setFollowersDashboardText(type);
    } else if (index === "1") {
      setViewsDashboardText(type);
    } else if (index === "2") {
      setLikesDashboardText(type);
    } else {
      setActivityDashboardText(type);
    }
  };

  const handleArrowClick = (index, direction) => {
    // Implement list slicing logic
  };

  if (loadingFollowers || loadingViews || loadingLikes || loadingActivity || loadingTopCities || loadingAge) {
    return <h4>Loading...</h4>;
  }

  return (
    <>
      <div className="divider_div2" />
      <div className="tab_body">
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            width: "100%",
            alignItems: "center"
          }}
        >
          {selectedGenre === "INSIGHT" ? (
            <>
              <FollowersDashboard
                index="0"
                dashboardText={followersDashboardText}
                handleDashboardClick={handleDashboardClick}
                handleArrowClick={handleArrowClick}
                dataList={followersList}
              />
              <ViewsDashboard
                index="0"
                dashboardText={viewsDashboardText}
                handleDashboardClick={handleDashboardClick}
                handleArrowClick={handleArrowClick}
                dataList={viewsList}
              />
              <LikesDashboard
                index="0"
                dashboardText={likesDashboardText}
                handleDashboardClick={handleDashboardClick}
                handleArrowClick={handleArrowClick}
                dataList={likesList}
              />
              <ActivityDashboard
                index="1"
                dashboardText={activityDashboardText}
                handleDashboardClick={handleDashboardClick}
                handleArrowClick={handleArrowClick}
                dataList={activityList}
              />
              <TopCitiesDashboard
                index="4"
                handleArrowClick={handleArrowClick}
                dataList={topCitiesList}
              />
              <AgeDashboard dataList={ageList} />
            </>
          ) : null}
        </div>
      </div>
    </>
  );
}

export default Activity;